import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../../../components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';
import { TiptapEditor } from './TiptapEditor';
import { DOC_TYPE_OPTIONS, EXPIRY_OPTIONS } from './documentConstants';

export const CreateTemplateDialog = ({
  open,
  onOpenChange,
  createTitle,
  setCreateTitle,
  createDocType,
  setCreateDocType,
  createContent,
  setCreateContent,
  createExpiresInDays,
  setCreateExpiresInDays,
  creating,
  onCreate,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Plus className="h-5 w-5 text-amber-500" />
          Create New Document Template
        </DialogTitle>
        <DialogDescription className="sr-only">Create New Document Template dialog. Use the form below to continue.</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label>Title</Label>
            <Input
              value={createTitle}
              onChange={(e) => setCreateTitle(e.target.value)}
              placeholder="e.g., Return Policy, NDA, Service Agreement"
              data-testid="create-title-input"
            />
          </div>
          <div>
            <Label>Document Type</Label>
            <Select value={createDocType} onValueChange={setCreateDocType}>
              <SelectTrigger data-testid="create-doc-type-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {DOC_TYPE_OPTIONS.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <div>
          <Label>Expiration Period</Label>
          <div className="flex items-center gap-3 mt-1">
            <Select value={createExpiresInDays} onValueChange={setCreateExpiresInDays}>
              <SelectTrigger className="w-48" data-testid="create-expires-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {EXPIRY_OPTIONS.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
            <p className="text-xs text-gray-400">After this period, acknowledged documents expire and require re-acknowledgment.</p>
          </div>
        </div>
        <div>
          <Label>Content</Label>
          {open && <TiptapEditor content={createContent} onChange={setCreateContent} />}
        </div>
      </div>
      <DialogFooter className="mt-4">
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          className="bg-amber-500 hover:bg-amber-600 text-white"
          onClick={onCreate}
          disabled={creating}
          data-testid="confirm-create-btn"
        >
          {creating ? 'Creating...' : 'Create Template'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
